// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAvailableRolloverToApplyResponse
 */
export interface IAvailableRolloverToApplyResponse {
    /**
     * 
     * @type {number}
     * @memberof IAvailableRolloverToApplyResponse
     */
    amount?: number | null;
}

/**
 * Check if a given object implements the IAvailableRolloverToApplyResponse interface.
 */
export function instanceOfIAvailableRolloverToApplyResponse(value: object): value is IAvailableRolloverToApplyResponse {
    return true;
}

export function IAvailableRolloverToApplyResponseFromJSON(json: any): IAvailableRolloverToApplyResponse {
    return IAvailableRolloverToApplyResponseFromJSONTyped(json, false);
}

export function IAvailableRolloverToApplyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAvailableRolloverToApplyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function IAvailableRolloverToApplyResponseToJSON(json: any): IAvailableRolloverToApplyResponse {
    return IAvailableRolloverToApplyResponseToJSONTyped(json, false);
}

export function IAvailableRolloverToApplyResponseToJSONTyped(value?: IAvailableRolloverToApplyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
    };
}

